var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_130_153)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.1562 1.3125H4.59375C2.78157 1.3125 1.3125 2.78157 1.3125 4.59375V11.1562C1.3125 12.9684 2.78157 14.4375 4.59375 14.4375H11.1562C12.9684 14.4375 14.4375 12.9684 14.4375 11.1562V4.59375C14.4375 2.78157 12.9684 1.3125 11.1562 1.3125Z",
    stroke: "white",
    strokeWidth: 1.50937,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5029 7.46164C10.5838 8.0078 10.4906 8.56559 10.2363 9.05568C9.98197 9.54577 9.57961 9.94319 9.08643 10.1914C8.59324 10.4397 8.03434 10.5261 7.48922 10.4383C6.9441 10.3506 6.44051 10.0933 6.0501 9.70284C5.65968 9.31242 5.40231 8.80884 5.31459 8.26372C5.22687 7.71859 5.31328 7.15969 5.56151 6.66651C5.80975 6.17332 6.20717 5.77097 6.69726 5.51667C7.18734 5.26238 7.74514 5.16909 8.2913 5.25008C8.8484 5.33269 9.36417 5.59229 9.76241 5.99053C10.1606 6.38877 10.4202 6.90453 10.5029 7.46164Z",
    stroke: "white",
    strokeWidth: 1.50937,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4844 4.26562H11.4909",
    stroke: "white",
    strokeWidth: 1.50937,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_130_153"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.75,
    height: 15.75,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.c23d47269b94e7f08c32fa2804d1ac1a.svg";
export { ForwardRef as ReactComponent };